import logo from "./media/logo.png";
import logoPost from "./media/logoPost.png";
import ceLogo from "./media/ce.png";
import backgroundImage from "./media/background.jpg";
import footerLogo from "./media/powered-by-healo.png";
import constants from "../../../../common/constants";
import SV_TRANSLATION from "./messages/sv";
import EN_TRANSLATION from "./messages/en";

const isProdEnv = process.env.REACT_APP_ENV === "production";

export default {
  name: "wellnet",
  image: logo,
  imagePost: logoPost,
  imageQA: logoPost,
  ceLogo: ceLogo,
  backGroundVideo: null,
  appBackground: {
    overlayStyle: {
      mixBlendMode: "soft-light",
      backgroundColor: "#ffa239"
    },
    url: backgroundImage
  },
  secondaryBackground: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    gradientColors: ["rgba(255, 255, 255, 0.9)", "rgba(255, 255, 255, 0.8)"]
  },
  footerImage: footerLogo,
  baseClass: "brand-wellnet",
  domains: [
    "http://localhost:4003",
    "https://dev-wellnet.healo.app",
    "https://stg-wellnet.healo.app",
    "https://wellnet.healo.app"
  ],
  clinicCityEnabled: false,
  //set clinic id for PROD
  clinicId: isProdEnv ? 1111 : 1105,
  ssnEnabled: true,
  anonymousEnabled: true,
  registrationWithEmailEnabled: true,
  registrationWithPhoneEnabled: true,
  emailVerificationEnabled: false,
  additionalSpaceOnRegistrationForm: true,
  translation: {
    [constants.appLanguages.sv]: SV_TRANSLATION,
    [constants.appLanguages.en]: EN_TRANSLATION
  }
};



// WEBPACK FOOTER //
// ./src/modules/brand/brands/wellnet/settings.js